import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonConfig, FireEvent } from '../../../global';
import { NgIf } from '@angular/common';
import { ButtonComponent } from '../buttons/button/button.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'slm-titled-card',
    templateUrl: './titled-card.component.html',
    imports: [NgIf, ButtonComponent, TranslatePipe]
})
export class TitledCardComponent {
  @Input() title = '';
  @Input() buttonConfig: ButtonConfig = null;
  @Output() fireEvent = new EventEmitter<FireEvent>();
}
